export default __webpack_public_path__ + "static/media/1-2411011451545a.c30343c2.jpg";